import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';

import CustomButton from '../../Componentization/CustomButton';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../../store';

import useSecureStorage from '../../../hooks/useSecureStorage';

import i18next from 'i18next'
import MontserratText from '../../../styles/MontserratText';

const SecuritySecretPhraseConfirmation = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const location = useLocation();
	const [currentPin, setCurrentPin] = useState(location.state === null ? "" : location.state.pincode);

	const { getWalletAddress, retrieveEncryptedData, getBlockChain } = useSecureStorage()

	const [secretPhrase, setSecretPhrase] = useState<string[]>([])

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "SecuritySecretPhraseConfirmation", "title": t('stack_header_message_09') }))
	}, [])

	useEffect(() => {
		const fetchMnemonic = async () => {
			const walletAddress = await getWalletAddress()
			const pinCode = currentPin
			if (walletAddress && pinCode) {
				try {
					const network = await getBlockChain()
					const data = await retrieveEncryptedData(network, pinCode)
					if (data && data.mnemonic) {
						const mnemonicArray = data.mnemonic.split(' ')
						setSecretPhrase(mnemonicArray)
					}

					// 처리가 끝난 후 location.state 초기화
					navigate(location.pathname, { replace: true, state: {} });
				} catch (error) {
					console.error('Failed to retrieve mnemonic 2 :', error)
				}
			} else {
				console.log(`pin data empty`)
			}
		}
		fetchMnemonic()
	}, [])

	const handleCopyToClipboard = () => {
		navigator.clipboard.writeText(secretPhrase.join(' '))
		.then(() => {
			alert(i18next.t('security_recovery_message_01'));
		})
		.catch(err => {
			console.error('Fail Copy:', err);
		});
	}

	const handleDone = () => {
		setCurrentPin('')
		setSecretPhrase([])
		
		navigate(`/SecuritySettings`, { replace: true, state: { } })
	}

	const renderPhrasePairs = () => {
		const pairs = []
		for (let i = 0; i < secretPhrase.length; i += 2) {
			pairs.push(
				<div key={i} style={styles.phraseRow}>
					<div style={styles.phraseItemLeft}>
						<MontserratText weight="medium" style={{ ...styles.phraseIndex, color: theme.primary_normal }}>
							{i + 1}
						</MontserratText>
						<MontserratText weight="medium" style={{ ...styles.phraseText, color: theme.label_strong }}>
							{secretPhrase[i]}
						</MontserratText>
					</div>

					{i + 1 < secretPhrase.length && (
						<div style={styles.phraseItemRight}>
							<MontserratText weight="medium" style={{ ...styles.phraseIndex, color: theme.primary_normal }}>
								{i + 2}
							</MontserratText>
							<MontserratText weight="medium" style={{ ...styles.phraseText, color: theme.label_strong }}>
								{secretPhrase[i + 1]}
							</MontserratText>
						</div>
					)}
				</div>
			)
		}
		return pairs
	}

	const styles = {
		container: {
			padding: "60px 24px 24px",
		} as React.CSSProperties,
		content: {
			width: "100%"
		} as React.CSSProperties,
		phraseContainer: {
			padding: 5,
			marginBottom: 32
		} as React.CSSProperties,
		phraseRow: {
			display: 'flex',
			justifyContent: 'space-between',
			marginBottom: 18
		} as React.CSSProperties,
		phraseItemLeft: {
			display: 'flex',
			alignItems: 'center',
			padding: 8,
			paddingTop: 5,
			paddingBottom: 5,
			border: `1px solid ${theme.line_alternative}`,
			borderRadius: 31,
			width: '48%',
			marginRight: 6
		} as React.CSSProperties,
		phraseItemRight: {
			display: 'flex',
			alignItems: 'center',
			padding: 8,
			paddingTop: 5,
			paddingBottom: 5,
			border: `1px solid ${theme.line_alternative}`,
			borderRadius: 31,
			width: '48%',
			marginLeft: 6
		} as React.CSSProperties,
		phraseIndex: {
			color: theme.text_08,
			padding: 5,
			marginRight: 5,
			fontSize: 16
		} as React.CSSProperties,
		phraseText: {
			color: theme.text_15,
			fontSize: 18,
			paddingLeft: 4
		} as React.CSSProperties,
		copyButton: {
			width: "100%",
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: 12,
			border: `1px solid ${theme.border_03}`,
			borderRadius: 10,
			marginBottom: 32
		} as React.CSSProperties,
		copyButtonText: {
			fontSize: 16,
			color: theme.text_08
		} as React.CSSProperties,
		confirmButton: {
			width: "100%",
			backgroundColor: theme.text_01,
			padding: "15px",
			borderRadius: 10,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		} as React.CSSProperties,
		confirmButtonText: {
			fontSize: 16,
			color: theme.static_white
		} as React.CSSProperties,
		buttonSecondary: {
            padding: '12px',
            borderRadius: '10px',
            marginBottom: '12px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            height: '54px',
            justifyContent: 'center',
        } as React.CSSProperties,
        buttonSecondaryText: {
            color: theme.text_01,
            fontSize: '16px',
            textAlign: 'center', // textAlignVertical을 대체
        } as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={styles.content}>
				{/* 구문 페어 렌더링 */}
				<div style={styles.phraseContainer}>
					{renderPhrasePairs()}
				</div>

			</div>

			<div style={{ width: "100%" }}>
				{/* 복사 버튼 */}
				<CustomButton
					containerStyle={{
						...styles.buttonSecondary, // 기존 스타일
					}}
					textStyle={{
						...styles.buttonSecondaryText, // 기존 스타일 병합
						color: theme.label_strong, // 추가 스타일 병합
					}}
					onPress={() => handleCopyToClipboard()}
					iconSize={15}
					text={t('security_recovery_message_02')}
					iconName="copy-outline"
					withBackground={true}
					backgroundColor={theme.background_09}
				/>

				{/* 확인 버튼 */}
				<CustomButton
					containerStyle={{ ...styles.confirmButton, backgroundColor: theme.primary_normal }}
					textStyle={styles.confirmButtonText}
					onPress={() => handleDone()}
					text={t('security_recovery_message_03')}
					withBackground={true}
					backgroundColor={theme.background_08}
				/>
			</div>
		</div>
	)
}

export default SecuritySecretPhraseConfirmation
